<template>  
	<div class="top-header-filter-inlclude">
		<div class="dataTable-headre  d-flex align-items-center justify-content-between mb-3">
			<div class="rightSearch d-flex align-items-center justify-content-between">
				<a href="#" @click="$parent.$parent.createTask = true" class="grd_btn btn_sm ml-2" v-if="listStatusFilter == 'TASK-LISTING' && showCreate == 'yes'">Create Task</a>
				<!---------------------show-record-filter------------------------------>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown w-150 mb-0" v-if="pageLimitFilter != 'disable'">
					<select class="float-field form-control" @change="pageLimitFunc()" v-model="pageLimit" >
						<option value="15">15</option>
						<option value="30">30</option>
						<option value="50">50</option>
					</select>
			    </div>
				<!--------------search------------------------------------------------->
				<div class="form-group parentClass has-search mx-2 mb-0 position-relative searchFT" v-if="searchFilter != 'disable'">
					
					<input type="text" class="form-control" placeholder="search here" v-model="search" v-on:keyup.enter="searchFunc()">
					<feather type="search" class="form-control-feedback text-right" @click="searchFunc()"></feather>
				</div>
				<!-----------------task-list-------------------------------------------->
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'TASK-LISTING'">
					<select class="float-field form-control" @change="showTaskListFunc()" v-model="taskStatusFilter">
						<option value="">select task type</option>
						<option value="1">Open</option>
						<option value="2">Close</option>
					</select>
			    </div>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'TASK-LISTING' && $parent.taskStatusFilter == '1' && $parent.ticket_group == ''">
					<select class="float-field form-control" @change="myClientTaskListFunc()" v-model="my_client_task">
						<option value="1">My Clients Task</option>
						<option value="0">My Task</option>
					</select>
			    </div>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'TASK-LISTING'  && $parent.taskStatusFilter == '1'">
					<select class="float-field form-control" @change="sortFieldFunc()" v-model="sort_field">
						<option value="">select sort option</option>
						<option value="task.created_at">Created Date</option>
						<option value="task.due_date">Due Date</option>
					</select>
			    </div>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'TASK-LISTING' && sort_field != ''  && $parent.taskStatusFilter == '1'">
					<select class="float-field form-control" @change="ascDescFunc()" v-model="asc_desc">
						<option value="">select sort option</option>
						<option value="ASC">Ascending Order</option>
						<option value="DESC">Descending Order</option>
					</select>
			    </div>
			    <!---------------------rm-accuracy------------------------------------>
				<div class="mobDT d-flex" v-if="listStatusFilter == 'RM-ACCURACY'">
					<label class="customCheckbox"> Show Rm with Accuracy 
					  <input type="checkbox" v-model="$parent.RmWithAccuracy">
					  <span class="checkmark"></span>
					</label>
					
					<a href="#" class="grd_btn btn-sm mr-3 bulkSave"   @click="$parent.bulkUpdate = true" v-if="!$parent.bulkUpdate">
						Bulk Update
					</a>
					<div class="d-flex align-items-center bulkSave mr-2" v-if="$parent.bulkUpdate">
						<a href="#" class="grd_btn btn-sm mr-2"  @click="$parent.bulkEditAccuracyFunc()" v-if="!$parent.ErrprMsz">
							Save
						</a>
						<a href="#" class="grd_btn btn-sm redBG mx-2"  @click="$parent.rmAccuracyBulkUpdate($parent.rmAccuracy.records) ; $parent.bulkUpdate = false ; $parent.ErrprMs = false" >
							Cancel
						</a>
					</div>
					<div class="d-flex selectFiltr-width" >
						<div class="form-group has-search mb-0 position-relative">
							<datepicker class="form-control border-0 p-0" v-model="fromDateLogs" placeholder="Enter From Date" format="YYYY-DD-MM" :lang="lang" ></datepicker>
						</div>
						<div class="form-group has-search ml-2 mb-0 position-relative">
							<datepicker class="form-control border-0 p-0" v-model="toDateLogs" placeholder="Enter To Date" format="YYYY-DD-MM" :lang="lang"></datepicker>
						</div>
						<a href="#" class="grd_btn btn-sm mx-2"   @click="lastDaysRecords('accuracy')" :class="(fromDateLogs != '' && toDateLogs != '' && fromDateLogs != 'Invalid date' && toDateLogs != 'Invalid date')?'':'disabled'">
							Submit
						</a>
					</div>
				</div>
				<!------------------notes------------------------------------------------>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'NOTES-LISTING' && $parent.ticket_group == ''">
					<select class="float-field form-control" @change="myClientTaskListFunc()" v-model="my_client_task">
						<option value="1">My Client Notes</option>
						<option value="0">My Notes</option>
					</select>
			    </div>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'NOTES-LISTING'">
					<select class="float-field form-control" @change="sortFieldFunc()" v-model="sort_field">
						<option value="">select sort option</option>
						<option value="NOTES.created_on">Created Date</option>
					</select>
			    </div>
				<div class="form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="listStatusFilter == 'NOTES-LISTING' && sort_field != ''">
					<select class="float-field form-control" @change="ascDescFunc()" v-model="asc_desc">
						<option value="">select sort option</option>
						<option value="ASC">Ascending Order</option>
						<option value="DESC">Descending Order</option>
					</select>
			    </div>


			  
				<!-------------------logs----------------------------------------------->
				<div class="form-group parentClass has-search mx-2 mb-0 position-relative" v-if="listStatusFilter == 'LOGS-LISTING' && $parent.service == 'communication/calls'">
					<date-picker1 v-model="startdates" lang="en" type="month" format="MM-YYYY"  @change="dateFocus()" ></date-picker1>
				</div>
				
				<div class="mobDT" v-if="listStatusFilter == 'LOGS-LISTING' && ($parent.service == 'communication' || $parent.service == 'express')">
					<div class="manualDate form-group parentClass-drop field-wrapper select-box-dropdown mb-0 ftList" v-if="showCustom == '1'">
						<select class="float-field form-control" @change="lastDaysRecords('1')" v-model="select_days">
							<option value="">select</option>
							<option value="7">Last 7 Days</option>
							<option value="15">Last 15 Days</option>
							<option value="30">Last 1 Month</option>
						</select>
						
						<a href="#" @click="fromDateLogs = '' ; toDateLogs = '' ; select_days = '' ; showCustom = '2' ; lastDaysRecords('')"><span class="orDi">or</span> manually select date</a>
					</div>
					<div class="d-flex align-items-center selectFiltr-width" v-if="showCustom == '2'">
						<div class="form-group has-search mb-0 position-relative">
							<datepicker class="form-control border-0 p-0" v-model="fromDateLogs" placeholder="Enter From Date"    format="YYYY-DD-MM" :lang="lang" ></datepicker>
						</div>
						<div class="form-group has-search ml-2 mb-0 position-relative">
							<datepicker class="form-control border-0 p-0" v-model="toDateLogs" placeholder="Enter To Date"    format="YYYY-DD-MM"  :lang="lang"></datepicker>
						</div>
						<a href="#" class="grd_btn btn-sm mx-2"   @click="lastDaysRecords('2')">
							submit
						</a>
						<a class="grd_btn btn-sm" href="#" @click="showCustom = '1' ; select_days = '' ; fromDateLogs = '' ; toDateLogs = '' ; lastDaysRecords('')">back</a>
					</div>
				</div>
				<!--------------------client-list--------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'CLIENT-LISTING' && (get_user.permissions.indexOf('CLIENT_DOWNLOAD') != -1)">
					<div class="acceptHold inlineList" >
						<!--- https://admin.fxview.com:2087/admin/get/user/reports --->
						<a href="#" class="grd_btn btn-sm"  @click="$parent.getClientReport()">
							Download Report
						</a>
					</div>
				</div>
				<!-------------reporting------------------------------------------------->
				<div class="d-flex align-items-center reportSlectDate" v-if="listStatusFilter == 'REPORTING'">
					<div v-if="$parent.report_status!='4' && $parent.report_status!='5'" class="form-group has-search mb-0 position-relative">
						<datepicker class="form-control p-0" v-model="fromDateField" placeholder="Enter From Date" format="YYYY-DD-MM" :lang="lang" ></datepicker>
					</div>
					<div v-if="$parent.report_status!='4' && $parent.report_status!='5'" class="form-group has-search mx-2 mb-0 position-relative">
						<datepicker class="form-control p-0" v-model="toDateField" placeholder="Enter To Date" format="YYYY-DD-MM"  :lang="lang"></datepicker>
					</div>
					<div v-if="$parent.report_status!='4' && $parent.report_status!='5'" class="form-group has-search mb-0 position-relative" >
						<a :href="reportDocLink+ dateFormat(fromDateField) +'&to='+ dateFormat(toDateField)" class="grd_btn btn-sm"  target="_blank()" :class="(fromDateField != '' && toDateField != '' && fromDateField != 'Invalid date' && toDateField != 'Invalid date')?'':'disabled'">
							Download Report
						</a>
					</div>
					<div v-if="$parent.report_status=='4'" class="form-group has-search mx-2 mb-0 position-relative">
						<a href="javascript:void(0);" @click="$parent.downloadDepositsList()" class="grd_btn btn-sm" :class="$parent.reportingList.totalRecords ? '': 'disabled'">
							Download Report
						</a>						
					</div>
					<div v-if="$parent.report_status=='5'" class="form-group has-search mb-0 position-relative">
						<datepicker class="form-control p-0" @change="(date) => $parent.filterTrades(date)" v-model="tradeDate" placeholder="Trade Date" :disabled-days="disabledDates" :lang="lang" ></datepicker>
					</div>
					<div v-if="$parent.report_status=='5'" class="form-group has-search mx-2 mb-0 position-relative">
						<a href="javascript:void(0);" @click="$parent.downloadTradesList()" class="grd_btn btn-sm" :class="$parent.reportingList.totalRecords ? '': 'disabled'">
							Download Report
						</a>						
					</div>
				</div>

				<!------------------------create-coupon---------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'CREATE-COUPON'">
					<div class="acceptHold inlineList" >
						<router-link  :to="'/coupon-listing'"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to List</router-link>  
					</div>
				</div>
				<!--------------------create-deposit-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'CREATE-DEPOSIT' || listStatusFilter == 'CREATE-TICKET' || listStatusFilter == 'CREATE-TRADING-ACCOUNT' || listStatusFilter == 'CREATE-WITHDRAWAL'">
					<div class="acceptHold inlineList" v-if="$parent.page == 'search'">
						<router-link  :to="{name: $parent.path}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to {{$parent.pageName}}</router-link>  
					</div>
					<div class="acceptHold inlineList" v-else>
						<router-link  :to="{name: $parent.path , query: {'id':$parent.user_id}}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to client detail</router-link>  
					</div>
				</div>
				<!--------------------search-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'SEARCH-LIST'">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: $parent.listPath}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>Back to {{$parent.pageName}} list</router-link>  
					</div>
				</div>
				<!--------------------trading-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING' && showCreate == 'yes' && permissionModule('TRADING_CREATE','view')">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'trading'}}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Trading Account</router-link>  
					</div>
				</div>
				
				<!---------------------manage-group-list---------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'GROUP-LISTING' ">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'mange_group.group_add_edit' , query: { 'id': ''}}"  class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Manage Group</router-link>  
					</div>
				</div>
				<!---------------------create-manage-group---------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'CREATE-MANAGER'">
					<div class="acceptHold inlineList">
						<router-link  :to="'/group-listing'"  class="grd_btn btn-sm d-flex align-items-center">
						<feather class="mr-2 customSize" type="chevron-left"></feather>back</router-link>  
					</div>
				</div>
				
				<!--------------------withdrawal-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'WITHDRAWAL-LISTING' && showCreate == 'yes' && permissionModule('WITHDRAWAL_CREATE','view')">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'withdrawal'}}" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Withdrawal</router-link>  
					</div>
					<div class="acceptHold inlineList">
						<a href="#" class="grd_btn btn-sm d-flex align-items-center" @click="$parent.withdrawalFile()">
						<feather type="download" class="mr-2 customSize"></feather>Download Withdrawal File</a>  
					</div>
				</div>
				
				<!--------------------ticket-list-------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'TICKET-LISTING' && showCreate == 'yes' && permissionModule('TICKET_CREATE','view')">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'ticket'}}" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Ticket</router-link>  
					</div>
				</div>
				
				
				<!--------------------deposit-list------------------------------------->
				<div class="userSelect bottomFix" v-if="(listStatusFilter == 'DEPOSIT-LISTING' && showCreate == 'yes') && (permissionModule('DEPOSIT_CREATE','view') || permissionModule('DEPOSIT_CREATE_EXEC','view'))">
					<div class="acceptHold inlineList">
						<router-link  :to="{name: 'shared.search' , query: { 'page':'deposit'}}" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Deposit</router-link>  
					</div>
					<div class="acceptHold inlineList">
						<a href="#" class="grd_btn btn-sm d-flex align-items-center" @click="depositFile()">
						<feather type="download" class="mr-2 customSize"></feather>Download Deposit File</a>  
					</div>
				</div>
				<div class="form-group field-wrapper select-box-dropdown mb-0"  v-if="(listStatusFilter == 'DEPOSIT-LISTING')">
					<select class="float-field form-control" @change="depositModeFunc()" v-model="depositMode">
						<option value="">Select Deposit Method</option>
						<option :value="key" v-for="(list,key) in depositMethod">{{list}}</option>
					</select>
			    </div>

			    <!--------------------chart-data----------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'DASHBOARD' && Object.keys($parent.csvData).length > 0 && (get_user.roles.indexOf('A') != -1 || get_user.roles.indexOf('BO') != -1 || get_user.roles.indexOf('CM-A') != -1)"> 
					<div class="acceptHold inlineList">
						<a href="#" class="grd_btn btn-sm d-flex align-items-center" @click="$parent.csvExport()">
						<feather type="plus" class="mr-2 customSize"></feather>Download Chart Data </a> 
					</div>
				</div>
				<!--------------------admin-list----------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'ADMIN-LISTING' && permissionModule('ADMIN_CREATE','view')">
					<div class="acceptHold inlineList">
						<router-link  :to="'/create-admin'" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="download" class="mr-2 customSize"></feather>create admin</router-link>  
					</div>
				</div>
				<!-----------------------tutorial-list---------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'TUTORIAL-LIST'">
					<div class="acceptHold inlineList">
						<router-link  :to="'/create-tutorial'" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>Create Tutorial</router-link>  
					</div>
				</div>
				<!--------------------email-list----------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'EMAIL-SETTING-LISTING'">
					<div class="acceptHold inlineList">
						<router-link  :to="'/create-email'" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>create email</router-link>  
					</div>
				</div>
				<!--------------------coupon-list----------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'COUPON-LISTING'">
					<div class="acceptHold inlineList">
						<router-link  :to="'/create-coupon'" class="grd_btn btn-sm d-flex align-items-center">
						<feather type="plus" class="mr-2 customSize"></feather>create coupon</router-link>  
					</div>
				</div>
				<!--------------------REPORTING----------------------------------------->
				<div class="userSelect bottomFix" v-if="listStatusFilter == 'REPORTING' && permissionModule('REPORT_CREATE','view')">
					<div class="acceptHold inlineList">
						<router-link  :to="'/create-collateral-report'" class="grd_btn btn-sm d-flex align-items-center" v-if="$parent.report_status == '0'">
							<feather type="plus" class="mr-2 customSize"></feather>create collateral portfolio report
						</router-link>  
						<router-link  :to="'/create-emir-report'" class="grd_btn btn-sm d-flex align-items-center" v-if="$parent.report_status == '1'">
							<feather type="plus" class="mr-2 customSize"></feather>create EMIR-Instruments report
						</router-link>  
						<router-link  :to="'/create-mifir-report'" class="grd_btn btn-sm d-flex align-items-center" v-if="$parent.report_status == '2'">
							<feather type="plus" class="mr-2 customSize"></feather>create MiFIR-Instruments report
						</router-link>  
						<router-link  :to="'/create-reporting-member-report'" class="grd_btn btn-sm d-flex align-items-center" v-if="$parent.report_status == '3'">
							<feather type="plus" class="mr-2 customSize"></feather>create reporting member report
						</router-link>  
					</div>
				</div>
				
				<div class="selectByamdin inFilter" v-if="((listStatusFilter == 'TICKET-LISTING' || listStatusFilter == 'CLIENT-LISTING' || listStatusFilter == 'DEPOSIT-LISTING' || listStatusFilter == 'TRADING-ACCOUNTS-LISTING' || listStatusFilter == 'WITHDRAWAL-LISTING' || listStatusFilter == 'NOTES-LISTING')  || (listStatusFilter == 'TASK-LISTING' && showCreate == 'no')) && (get_user.groups.length > 0) && ($parent.ticket_group != '')">
				   <div class="dropdown text-right">
					  <a class="selectDrop d-flex align-items-center justify-content-center" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						<img src="../../../../static/fxView/images/menu-green.svg" alt="Icon">
					  </a>
					  <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton">
						<a href="#" @click="adminGroupNameFilterFunc('')" :class="($parent.adminGroupNameFilter == '')?'active':''">All</a>
						<a href="#" @click="adminGroupNameFilterFunc(list.ID)" :class="(parseInt($parent.adminGroupNameFilter) == parseInt(list.ID))?'active':''" v-for="list in groupAdminName[$parent.ticket_group]">{{list.NAME}}</a>
					  </div>
					</div> 
				</div>
			</div> 
		</div>
		<ul class="topbar_tabs nav nav-tab top-fixlabel mb-4 border-bottom" v-if="((listStatusFilter == 'TICKET-LISTING' || listStatusFilter == 'CLIENT-LISTING' || listStatusFilter == 'DEPOSIT-LISTING' || listStatusFilter == 'TRADING-ACCOUNTS-LISTING' || listStatusFilter == 'WITHDRAWAL-LISTING' || listStatusFilter == 'NOTES-LISTING')  || (listStatusFilter == 'TASK-LISTING' && showCreate == 'no') ) && (get_user.groups.length > 0)">
			<li><a :class="($parent.ticket_group == '')?'active' : ''" href="#" @click="ticketGroupFunc('')"><span></span>My 
				<label v-if="listStatusFilter == 'CLIENT-LISTING'">Clients</label>
				<label v-else-if="listStatusFilter == 'DEPOSIT-LISTING'">Deposits</label>
				<label v-else-if="listStatusFilter == 'WITHDRAWAL-LISTING'">Withdrawals</label>
				<label v-else-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING'">Trading Accounts</label>
				<label v-else-if="listStatusFilter == 'TASK-LISTING'">Task</label>
				<label v-else-if="listStatusFilter == 'NOTES-LISTING'">Notes</label>
				<label v-else>Tickets</label>
				</a>
			</li>
			<li v-for="list in get_user.groups">
				<a  :class="($parent.ticket_group == list.group_id)?'active' : ''" href="#" @click="ticketGroupFunc(list.group_id)"><span></span> {{list.name}}</a>
			</li>
		</ul>
		<!---------------------------->
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="(listStatusFilter == 'WITHDRAWAL-ACCOUNT-LIST') && (get_user.roles.indexOf('AC-A') != -1)">
			<li><a :class="($parent.flag == '1')?'active' : ''" href="#" @click="$parent.flag = '1'"><span></span>For Maker</a></li>
			<li><a  :class="($parent.flag == '2')?'active' : ''" href="#" @click="$parent.flag = '2'"><span></span>For Checker</a></li>
			<li><a  :class="($parent.flag == '3')?'active' : ''" href="#" @click="$parent.flag = '3'"><span></span>All</a></li>
			<li><a  :class="($parent.flag == '4')?'active' : ''" href="#" @click="$parent.flag = '4'"><span></span>Download Files</a></li>
			<li><a  :class="($parent.flag == '5')?'active' : ''" href="#" @click="$parent.flag = '5'"><span></span>Upload Files</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-else-if="(listStatusFilter == 'WITHDRAWAL-ACCOUNT-LIST') && (get_user.roles.indexOf('AC-M') != -1)">
			<li><a  :class="($parent.flag == '2')?'active' : ''" href="#" @click="$parent.flag = '2'"><span></span>For Checker</a></li>
			<li><a  :class="($parent.flag == '4')?'active' : ''" href="#" @click="$parent.flag = '4'"><span></span>Download Files</a></li>
			<li><a  :class="($parent.flag == '5')?'active' : ''" href="#" @click="$parent.flag = '5'"><span></span>Upload Files</a></li>
		</ul>
		<!----------------------------------->

		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'LOGS-LISTING'">
			<li><a :class="($parent.service == 'express')?'active' : ''" href="#" @click="$parent.service = 'express' ; $parent.listing()"><span></span>Express</a></li>
			<li><a :class="($parent.service == 'communication')?'active' : ''" href="#" @click="$parent.service = 'communication' ; $parent.listing()"><span></span>Communication</a></li>
			<li><a :class="($parent.service == 'communication/calls')?'active' : ''" href="#" @click="$parent.service = 'communication/calls' ; $parent.listing()"><span></span>Calls</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'TRADING-ACCOUNTS-LISTING'">
			<li><a :class="($parent.demo_live == '0')?'active' : ''" href="#" @click="showAccountList('0')"><span></span>Demo Accounts</a></li>
			<li><a  :class="($parent.demo_live == '1')?'active' : ''" href="#" @click="showAccountList('1')"><span></span>Live Accounts</a></li>
		</ul>
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'WITHDRAWAL-LISTING' ">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click="withdrawalFilter('')"><span></span>All</a></li>
			<li><a  :class="($parent.listStatus == '0')?'active' : ''" href="#" @click="withdrawalFilter('0')"><span></span>Pending</a></li>
			<li><a :class="($parent.listStatus == '1')?'active' : ''" href="#" @click="withdrawalFilter('1')"><span></span>Processed</a></li>
			<li><a  :class="($parent.listStatus == '3')?'active' : ''" href="#" @click="withdrawalFilter('3')"><span></span>Rejected</a></li>
		</ul>
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'INTERNAL-DEPOSIT-LISTING'">
			<li><a :class="($parent.tab == '1')?'active' : ''" href="#" @click="internalDepositSuspenseListFunc('1','113')"><span></span>Internal Deposit</a></li>
			<li><a  :class="($parent.tab == '2')?'active' : ''" href="#" @click="internalDepositSuspenseListFunc('2','114')"><span></span>Suspense</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'TICKET-LISTING' || listStatusFilter == 'INTERNAL-DEPOSIT-LISTING'">
			<li><a :class="($parent.ticket_status == '0')?'active' : ''" href="#" @click="$parent.maker_done = '0' ; ticketStatusList('0')"><span></span>Open</a></li>
			<li><a  :class="($parent.ticket_status == '3')?'active' : ''" href="#" @click="$parent.maker_done = '' ; ticketStatusList('3')"><span></span>Close</a></li>
		</ul>

		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'NOTIFICATION-LIST'">
			<li><a :class="($parent.tab == '1')?'active' : ''" href="#" @click="$parent.tab = '1' ; $parent.page = '1'; $parent.pageLimit = 15;$parent.notificate = ''; $parent.listing()"><span></span>All</a></li>
			<li><a  :class="($parent.tab == '2')?'active' : ''" href="#" @click="$parent.tab = '2' ; $parent.page = '1'; $parent.pageLimit = 15;$parent.notificate = ''; $parent.listing()"><span></span>Sum & Sub</a></li>
		</ul>
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="(listStatusFilter == 'TICKET-LISTING') && (get_user.roles.indexOf('BO-A') != -1 || get_user.roles.indexOf('BO-M') != -1 || get_user.roles.indexOf('AC-A') != -1 || get_user.roles.indexOf('AC-M') != -1  || get_user.roles.indexOf('IT-A') != -1 || get_user.roles.indexOf('IT-M') != -1  || get_user.roles.indexOf('RMS-A') != -1 || get_user.roles.indexOf('RMS-M') != -1 || get_user.roles.indexOf('RM-M') != -1 || get_user.roles.indexOf('RM-A') != -1) && ($parent.ticket_status == '0')">
			<li><a :class="($parent.maker_done == '')?'active' : ''" href="#" @click="makerChecker('')"><span></span>All</a></li>
			<li><a  :class="($parent.maker_done == '0')?'active' : ''" href="#" @click="makerChecker('0')"><span></span>Maker Pending</a></li>
			<li><a :class="($parent.maker_done == '1')?'active' : ''" href="#" @click="makerChecker('1')"><span></span>Maker Done</a></li>
			
			<li><a  :class="($parent.maker_done == '2')?'active' : ''" href="#" @click="makerChecker('2')"><span></span>Escalated Ticket</a></li>
		</ul>
		
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="(listStatusFilter == 'INTERNAL-DEPOSIT-LISTING') && (get_user.roles.indexOf('AC-A') != -1 || get_user.roles.indexOf('AC-M') != -1) && ($parent.ticket_status == '0')">
			<li><a :class="($parent.maker_done == '')?'active' : ''" href="#" @click="makerChecker('')"><span></span>All</a></li>
			<li><a  :class="($parent.maker_done == '0')?'active' : ''" href="#" @click="makerChecker('0')"><span></span>Maker Pending</a></li>
			<li><a :class="($parent.maker_done == '1')?'active' : ''" href="#" @click="makerChecker('1')"><span></span>Maker Done</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'DEPOSIT-LISTING'">
			<li><a :class="($parent.listStatus == '')?'active' : ''" href="#" @click="depositFilter('')"><span></span>All</a></li>
			<li><a  :class="($parent.listStatus == '0')?'active' : ''" href="#" @click="depositFilter('0')"><span></span>Pending</a></li>
			<li><a :class="($parent.listStatus == '1')?'active' : ''" href="#" @click="depositFilter('1')"><span></span>Success</a></li>
		</ul>
		<ul class="topbar_tabs nav nav-tab mb-4 border-bottom" v-if="listStatusFilter == 'REPORTING'">
			<li><a :class="($parent.report_status == '0')?'active' : ''" href="#" @click="reportStatusList('0')"><span></span>Collateral Portfolio</a></li>
			<li><a :class="($parent.report_status == '1')?'active' : ''" href="#" @click="reportStatusList('1')"><span></span>EMIR-Instruments</a></li>
			<li><a :class="($parent.report_status == '2')?'active' : ''" href="#" @click="reportStatusList('2')"><span></span>MiFIR-Instruments</a></li>
			<li><a :class="($parent.report_status == '3')?'active' : ''" href="#" @click="reportStatusList('3')"><span></span>Reporting Member</a></li>
			<li><a :class="($parent.report_status == '4')?'active' : ''" href="#" @click="reportStatusList('4')"><span></span>Client Deposits</a></li>
			<li><a :class="($parent.report_status == '5')?'active' : ''" href="#" @click="reportStatusList('5')"><span></span>Trades</a></li>
		</ul>
	</div>
</template>
<script>   
	import { fxViewMixins } from '@/plugins/fxView'
	import moment from 'moment'
	import DatePicker1 from 'vue2-datepicker'
	export default{
	  name: 'FILTERS',
	  mixins: [fxViewMixins],
	  data(){
		return { 
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
				monthBeforeYear: false,
			},
			toDateField : '',
			fromDateField : '',
			//=======================logs===============================
			startdates : moment().format("MM-YYYY") ,  
			select_days : '7',
			fromDateLogs : '',
			toDateLogs : '',
			showCustom : '1',
			//=========================================================
			search : '',
			pageLimit : '15',
			delayTimer : null,
			//======================ticket-list==========================
			listStatus : '',
			ticket_Filter : '',
			read_ticket : '',
			//======================deposit-list==========================
			depositMode : '',
			//======================task=================================
			taskStatusFilter : '1', 
			my_client_task : '0',
			sort_field : this.$parent.sort_field,    
			asc_desc : this.$parent.asc_desc,
			notification : '',
			tradeDate: null
		}
	  },
		components: {
			DatePicker1
		},
		created() {
			let day = moment().subtract(1, 'days').day()
			let date = (day != 0 && day != 6) ? moment().subtract(1, 'days') : ((day == 0) ? moment().subtract(3, 'days') : moment().subtract(2, 'days')) 
			this.tradeDate = new Date(date)
		},
	  props:['pageLimitFilter','searchFilter','listStatusFilter','showCreate'],
	  methods:{
		disabledDates(date) {
			const today = new Date();
			today.setHours(0, 0, 0, 0);

			return date >= today || moment(date).day() == 6  || moment(date).day() == 0
    	},
		dateFormat(date){
			return moment(date).format('YYYY-DD-MM')
		},
		adminGroupNameFilterFunc(getData){
			this.$parent.adminGroupNameFilter = getData
			this.$parent.listing()
		},
		//======================logs=================================
		dateFocus(){
			if(this.startdates != null){
				this.$parent.startdates =  moment(this.startdates).format("MM-YYYY")
				this.$parent.listing()
			}else{
				this.startdates =  ''
				this.$parent.startdates =  ''
				this.$parent.listing()
			}
		},
		lastDaysRecords(getData){
			if(getData == '1'){
				if(this.select_days != ''){
					this.$parent.from = moment().subtract(parseInt(this.select_days),'d').format("YYYY-MM-DD HH:mm:ss")
					this.$parent.to = moment().format("YYYY-MM-DD HH:mm:ss")
					this.$parent.listing()
				}else{
					this.$parent.from = ''
					this.$parent.to = ''
					this.$parent.listing()
				}
			}else if(getData == '2'){
				if(this.fromDateLogs != '' && this.fromDateLogs != null && this.fromDateLogs != 'Invalid date'){
					this.$parent.from =  moment(this.fromDateLogs).format("YYYY-MM-DD HH:mm:ss")
				}else{
					this.$parent.from =  ''
				}
				
				if(this.toDateLogs != '' && this.toDateLogs != null && this.toDateLogs != 'Invalid date'){
					this.$parent.to =  moment(this.toDateLogs).format("YYYY-MM-DD HH:mm:ss")
				}else{
					this.$parent.to =  ''
				}
				this.$parent.listing()
			}else{
				this.$parent.from =  ''
				this.$parent.to =  ''
				this.$parent.listing()
			}
		},
		//======================task-list===========================
		showTaskListFunc(){
			this.$parent.taskStatusFilter = this.taskStatusFilter
			if(parseInt(this.taskStatusFilter) == 2){
				this.$parent.sort_field = ''
				this.$parent.asc_desc = ''
			}
			
			this.$parent.listing()
		},
		myClientTaskListFunc(){
			this.$parent.my_client_task = this.my_client_task
			this.$parent.listing()
		},
		sortFieldFunc(){
			this.$parent.sort_field = this.sort_field
			if(this.$parent.asc_desc != ''){
				this.$parent.listing()
			}
			//
		},
		ascDescFunc(){
			this.$parent.asc_desc = this.asc_desc
			this.$parent.listing()
		},

		//------------------notification---------------------------

		
		//======================ticket-list==========================
		makerChecker(getData){
			this.$parent.maker_done = getData
			this.$parent.listing()
		},
		internalDepositSuspenseListFunc(getData,ticketReason){
			this.$parent.tab = getData
			this.$parent.ticketReason1 = ticketReason
			this.$parent.ticket_status = '0'
			this.resetdata()
		},
		ticketStatusList(getData){
			this.$parent.ticket_status = getData
			this.resetdata()
		},
		ticketGroupFunc(getData){
			this.$parent.adminGroupNameFilter = ''
			this.$parent.ticket_group = getData
			this.$parent.listing()
		},
		//======================deposit-list==========================
		depositModeFunc(){
			this.$parent.page = '1'
			this.$parent.depositMode = this.depositMode
			this.$parent.listing()
		},
		depositFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		depositFile(){
			this.$parent.depositFile()
			
		},
		//=====================withdrawal-list=======================
		withdrawalFilter(getData){
			this.$parent.listStatus = getData
			this.resetdata()
		},
		//=====================trading-list==========================
		showAccountList(getData){
			this.$parent.demo_live = getData
			this.resetdata()
		},
		//=====================reporting=============================
		reportStatusList(getData){
			this.$parent.report_status = getData
			this.resetdata()
		},
		//=====================common=================================
		resetdata(){
			this.$parent.page = '1'
			this.$parent.search = ''
			this.$parent.pageLimit = '15'
			this.search = this.$parent.search
			this.pageLimit = this.$parent.pageLimit
			this.$parent.listing()
		},
		pageLimitFunc(){
			this.$parent.pageLimit = this.pageLimit
			this.$parent.listing()
		},
		searchFunc(){
			this.$parent.page = '1'
			this.$parent.search = this.search
			this.$parent.listing()
			
		},


	  }
	}
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/top_header_title.vue